import React from "react";
import {NavLink} from "react-router-dom";
import './PrivacyPolicy.scss';

const PrivacyPolicyPl = props => {
    return (
        <div className='PrivacyPolicy'>
            {props.backButton &&
                <NavLink
                    exact to='/start'
                    className='documentBackButton'
                >
                    <span className="material-icons">
                        arrow_back
                    </span>
                    BACK
                </NavLink>
            }

            <h1>
                <strong>Polityka prywatności</strong>
            </h1>
            <p>
                Agronet stworzył aplikację [AgroNet] jako bezpłatną aplikację. Ta USŁUGA jest świadczona przez Agronet bezpłatnie i jest przeznaczona do użytku w takiej postaci, w jakiej jest.
            </p>
            <p>
                Ta strona służy do informowania odwiedzających o naszych zasadach dotyczących gromadzenia, wykorzystywania i ujawniania danych osobowych, jeśli ktoś zdecyduje się skorzystać z naszej Usługi.
            </p>
            <p>
                Jeśli zdecydujesz się skorzystać z naszej Usługi, zgadzasz się na zbieranie i wykorzystywanie informacji w związku z niniejszą polityką. Dane osobowe, które zbieramy, służą do świadczenia i ulepszania Usługi. Nie będziemy wykorzystywać ani udostępniać Twoich danych nikomu, z wyjątkiem przypadków opisanych w niniejszej Polityce prywatności.
            </p>
            <p>
                Pojęcia użyte w niniejszej Polityce prywatności mają takie samo znaczenie jak w naszym Regulaminie, który jest dostępny pod adresem [AgroNet], chyba że określono inaczej w niniejszej Polityce prywatności.
            </p>
            <p>
                <strong> Gromadzenie i wykorzystywanie informacji</strong>
            </p>
            <p>
                Aby zapewnić lepsze wrażenia podczas korzystania z naszej Usługi, my może wymagać, abyś przekazał nam pewne dane osobowe informacje umożliwiające identyfikację, w tym między innymi imię i nazwisko. Informacje, które o które poprosimy, będą przez nas przechowywane i wykorzystywane zgodnie z opisem w niniejszej polityce prywatności.
            </p>
            <div>
                <p>
                    Aplikacja korzysta z usług stron trzecich, które mogą gromadzić dane informacje służące do identyfikacji użytkownika.
                </p>
                <p>
                    Link do polityki prywatności wykorzystywanych usługodawców zewnętrznych przez aplikację
                </p>
                <ul>
                    <li>
                        <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">
                            Google Play Services
                        </a>
                    </li>
                    <li>
                        <a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer">
                            Firebase Crashlytics
                        </a>
                    </li>
                </ul>
            </div>
            <p>
                <strong>Log Data</strong>
            </p>
            <p>
                Chcemy Cię poinformować, że zawsze skorzystaj z naszego serwisu w przypadku błędu w aplikacji zbieramy dane i informacje (za pośrednictwem stron trzecich produktów) w telefonie o nazwie Dane dziennika. Te dane dziennika mogą zawierać informacje, takie jak protokół internetowy urządzenia („IP”) adres, nazwa urządzenia, wersja systemu operacyjnego, konfiguracja aplikacji podczas korzystania z naszego Serwisu, godzina i data korzystania z Usługi i inne Statystyka.
            </p>
            <p>
                <strong>Cookies</strong>
            </p>
            <p>
                Pliki cookie to pliki zawierające niewielką ilość danych powszechnie używane jako anonimowe unikalne identyfikatory. Te są wysyłane do przeglądarki z witryn internetowych, które odwiedzasz przechowywane w pamięci wewnętrznej Twojego urządzenia.
            </p>
            <p>
                Ta usługa nie wykorzystuje tych „plików cookie” w sposób wyraźny. Jednak, aplikacja może korzystać z kodu stron trzecich i bibliotek, które używają „Cookies” w celu zbierania informacji i ulepszania ich usług. Możesz zaakceptować lub odrzucić te pliki cookie i wiedzieć, kiedy plik cookie jest wysyłany na Twoje urządzenie. Jeśli ty zdecydujesz się odrzucić nasze pliki cookie, możesz nie być w stanie korzystać z niektórych  części tej Usługi.
            </p>
            <p>
                <strong>Dostawcy usług</strong>
            </p>
            <p>
                Możemy zatrudniać firmy zewnętrzne i osoby z następujących powodów:
            </p>
            <ul>
                <li> Aby ułatwić naszą Usługę; </li>
                <li> Aby świadczyć Usługę w naszym imieniu; </li>
                <li> Aby świadczyć usługi związane z Usługą; lub </li>
                <li> Aby pomóc nam w analizie sposobu korzystania z naszej Usługi. </li>
            </ul>
            <p>
                Chcemy poinformować użytkowników o tej usłudze że te osoby trzecie mają dostęp do Twoich danych osobowych Informacja. Powodem jest wykonanie powierzonych zadań je w naszym imieniu. Jednak są do tego zobowiązani ujawniać ani wykorzystywać informacji w jakimkolwiek innym celu.
            </p>
            <p>
                <strong>Bezpieczeństwo</strong>
            </p>
            <p>
                Cenimy Twoje zaufanie, które daje nam Dane osobowe, dlatego staramy się wykorzystywać je komercyjnie akceptowalne sposoby jego ochrony. Ale pamiętaj, że nie ma metody transmisji przez Internet lub drogą elektroniczną przechowywanie jest w 100% bezpieczne i niezawodne, a my nie możemy gwarantuje całkowite bezpieczeństwo.
            </p>
            <p>
                <strong>Linki do innych witryn</strong>
            </p>
            <p>
                Ta Usługa może zawierać łącza do innych witryn. Jeśli klikniesz link strony trzeciej, zostaniesz przekierowany do tej witryny. Uwaga że te zewnętrzne strony nie są przez nas obsługiwane. Dlatego zdecydowanie zalecamy zapoznanie się z Polityka prywatności tych witryn. Mamy brak kontroli i nie ponosimy odpowiedzialności za treść, polityki prywatności lub praktyki wszelkich witryn osób trzecich lub usługi.
            </p>
            <p>
                <strong>Prywatność dzieci</strong>
            </p>
            <p> Usługi te nie są skierowane do osób poniżej 13 roku życia. Nie zbieramy świadomie osobiście informacje umożliwiające identyfikację od dzieci poniżej 13. roku życia odkrywamy, że zapewniło to dziecko poniżej 13 roku życia nam dane osobowe, natychmiast usuń to z naszych serwerów. Jeśli jesteś rodzicem lub opiekunem i masz świadomość, że Twoje dziecko nam to zapewniło dane osobowe, prosimy o kontakt w celu będziemy w stanie wykonać niezbędne czynności.
            </p>
            <p>
                <strong>Zmiany w niniejszej Polityce prywatności</strong>
            </p>
            <p>
                Możemy zaktualizować naszą Politykę prywatności pod adresem od czasu do czasu. Dlatego radzimy przejrzeć tę stronę okresowo w przypadku jakichkolwiek zmian. Będziemy powiadomić Cię o wszelkich zmianach, zamieszczając nową Politykę prywatności na ta strona.
            </p>
            <p>
                Niniejsza polityka obowiązuje od 2020-09-24
            </p>
            <p>
                <strong>Skontaktuj się z nami</strong>
            </p>
            <p>
                Jeśli masz jakieś pytania lub sugestie dotyczące naszego Polityka prywatności, zachęcamy do kontaktu pod numerem telefonu +48887738877.
            </p>

</div>
    );
};

export default PrivacyPolicyPl;
